var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-relative-100 mh-vh-100-nav p-3"},[_c('SubHeader',{attrs:{"title":"취소대기"}}),_c('ReservationItem',{attrs:{"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }